import { useTypedParams } from "react-router-typesafe-routes";

import { ClientApplicationCard } from "@components/ClientApplication/ClientApplicationCard/ClientApplicationCard";
import { ClientApplicationReviewCard } from "@components/ClientApplication/ClientApplicationReviewCard";

import { Box } from "@design-system/Box/Box";

import { routes } from "@pages/routes";

export const ApplicationRecord = () => {
  const { clientId, applicationId } = useTypedParams(
    routes.portal.clients.client.applications.application,
  );

  return (
    <Box direction="column" gap={8} fullStretch>
      <ClientApplicationReviewCard
        clientId={clientId}
        clientApplicationId={applicationId}
      />
      <ClientApplicationCard
        clientId={clientId}
        clientApplicationId={applicationId}
      />
    </Box>
  );
};
